import axios from 'axios';
import countries from '../country.json';

const OAUTH_URL = `${countries.co.host}/core-home-proxy/cauth/oauth`;

export const describeMcpRequest = async (request) => {
    const response = await axios.get(`${OAUTH_URL}/request`, { params: { request } });
    return response.data;
};

export const approveMcpClient = async (request, token) => {
    const response = await axios.post(`${OAUTH_URL}/approve`, { request }, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};
